import React, { useEffect, useState } from 'react';
import { Header, AboutSection, PortFolioDisplay, RupsBar, ParallaxSection, ContactSection, FooterSection, LoadingScreen, RupsLogoController } from './components';
import { fetchContent } from './utils/contentFetcher';

function App() {
  const [language, setLanguage] = useState('nl');
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getContent = async () => {
      setLoading(true);
      const data = await fetchContent(language);
      setContent(data);

      // Set SEO metadata dynamically
      if (data) {
        document.title = data.seo_title;

        // Ensure the description meta tag exists
        let metaDescription = document.querySelector('meta[name="description"]');
        if (!metaDescription) {
          metaDescription = document.createElement('meta');
          metaDescription.name = 'description';
          document.head.appendChild(metaDescription);
        }
        metaDescription.setAttribute('content', data.seo_description);

        let manifestLink = document.querySelector('link[rel="manifest"]');
        if (!manifestLink) {
          manifestLink = document.createElement('link');
          manifestLink.rel = 'manifest';
          document.head.appendChild(manifestLink);
        }
        manifestLink.setAttribute('href', data.manifest);
        setLoading(false);
      }

    };
    getContent();
  }, [language]);

  useEffect(() => {
    const path = window.location.pathname;
    if (path.startsWith('/en/')) {
      setLanguage('en');
    }
  }, []);

  useEffect(() => {
    const search = window.location.search;
    if (language === 'en') {
      window.history.pushState(null, '', `/en/${search}`);
    } else {
      window.history.pushState(null, '', `/${search}`);
    }
  }, [language]);

  if (loading) {
    return <LoadingScreen />;
  }

  // console.log(content);

  return (
    <div className="min-h-screen flex flex-col bg-green-800 overflow-x-hidden">
      <main className="flex-grow flex flex-col justify-center px-4 sm:px-6 lg:px-8 max-w-screen-lg lg:mx-auto w-full">
        <RupsLogoController />
        {content && <AboutSection content={content} language={language} />}
        <RupsBar />
        {content && <Header content={content} language={language} setLanguage={setLanguage} />}
        <ParallaxSection src='/assets/images/coffee.jpg' height="40" />
        {content && <PortFolioDisplay content={content} language={language} />}
        <ParallaxSection src='/assets/images/notebook.jpg' height="40" />
        {content && <ContactSection id="contact" content={content} language={language} />}
        {content && <FooterSection id="footer" content={content} language={language} />}
      </main>
    </div>
  );
}

export default App;